<template>
  <div>
    <FilterTab>
      <!-- <template v-slot:title><h6>Driver</h6></template> -->
      <template v-slot:body> </template>
      <template v-slot:button1>
        <button
          v-if="hasPermission(Admin.companyDeployWrite)"
          class="edit_table_data font_detail"
          @click="addModal"
        >
          <i class="fas fa-plus"></i><span class="mx-1 bold">Add New</span>
        </button>
      </template>
    </FilterTab>
    <Table v-if="$store.getters.getDrivers">
      <template v-slot:header>
        <tr>
          <td class="font_detail">SL</td>
          <td class="font_detail">NAME</td>
          <td class="font_detail">MOBILE</td>
          <td class="font_detail">EMAIL</td>
          <td class="font_detail">STATUS</td>
          <td
            v-if="hasPermission(Admin.companyDeployWrite)"
            class="font_detail"
          >
            ACTION
          </td>
        </tr>
      </template>

      <template v-slot:body>
        <tr
          v-for="(driver, index) in $store.getters.getDrivers"
          :key="driver._id"
        >
          <td class="font_detail">
            {{ index + 1 + (pagination.page - 1) * 25 }}
          </td>
          <td class="font_detail">{{ driver.name }}</td>
          <td class="font_detail">{{ driver.phone }}</td>
          <td class="font_detail">{{ driver.email }}</td>

          <td>
            <span v-if="driver.status" class="badge bg-success">{{
              dropdownVariables.status[1]
            }}</span>
            <span v-else class="badge bg-danger">{{
              dropdownVariables.status[0]
            }}</span>
          </td>
          <td v-if="hasPermission(Admin.companyDeployWrite)">
            <button
              class="edit_table_data font_detail edit_table_button"
              @click="updateModal(driver._id)"
            >
              <i class="fas fa-edit"></i><span class="mx-1">Edit</span>
            </button>
          </td>
        </tr>
      </template>
      <template v-slot:pagination>
        <pagination
          v-model="pagination.page"
          :records="$store.getters.getTotalDrivers"
          :per-page="pagination.limit"
          @paginate="getAllDriver"
          :options="options"
        />
      </template>
    </Table>
    <div v-if="showModal">
      <DriverAddUpdateModal
        v-model="showModal"
        @getAllDrivers="getAllDriver"
        v-bind:company="companyId"
        v-bind:driver="driverId"
      />
    </div>
  </div>
</template>

<script>
import store from "@/store";
import { useRoute } from "vue-router";
import { onBeforeMount, reactive, ref, inject } from "vue";
import permission from "@/modules/permission";
import roles from "@/modules/roles";
import dropdownVariables from "@/modules/dropdownVariables";
import DriverAddUpdateModal from "./DriverAddUpdateModal.vue";

const { hasPermission } = permission();
const { Admin } = roles();
export default {
  name: "Supervisor",
  components: {
    DriverAddUpdateModal,
  },
  setup() {
    const companyId = ref("");
    const driverId = ref("");
    const showLoader = inject("showLoader");
    const hideLoader = inject("hideLoader");
    const showModal = ref(false);

    const pagination = reactive({
      companyId,
      page: 1,
      limit: 25,
    });
    const options = {
      texts: {
        count: "",
      },
    };

    const getAllDriver = () => {
      showLoader();
      store
        .dispatch("getDriversByPage", pagination)
        .then(() => {
          hideLoader();
        })
        .catch((error) => {
          hideLoader();
          if (error.status === 401) {
            getAllDriver();
          }
        });
    };

    const updateModal = (value) => {
      driverId.value = value;
      showModal.value = true;
    };
    const addModal = () => {
      driverId.value = "";
      showModal.value = true;
    };

    onBeforeMount(() => {
      companyId.value = useRoute().query.id;
      getAllDriver();
    });
    return {
      companyId,
      driverId,
      pagination,
      getAllDriver,
      updateModal,
      hasPermission,
      Admin,
      options,
      dropdownVariables,
      showModal,
      addModal,
    };
  },
};
</script>

<style scoped>
.bold {
  font-weight: bold;
}
</style>
